// extracted by mini-css-extract-plugin
module.exports = {"boxContainer":"_2sWPJxgZjsr04Ez2XjH78T","boxInfo":"_1gSK0I94Z9Zc12zh7eBHrb"};